import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e5aeede"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Loading histo-pheno data")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Error loading histo-pheno data")

import { useRoute } from "vue-router";
import Apex from "vue3-apexcharts";
import { getHistoPheno } from "@/api/histo-pheno";
import { Node } from "@/api/node-lookup";
import { useQuery } from "@/util/composables";
import { computed, watch } from "vue";
import theme from "@/global/variables.module.scss";

/** route info */
interface Props {
  /** current node */
  node: Node;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HistoPheno',
  props: {
    node: null
  },
  setup(__props: any) {

const props = __props as {
  /** current node */
  node: Node;
}

const route = useRoute();



/** chart options */
const options = computed(() => ({
  chart: {
    id: "histo-pheno",
    type: "bar",
    redrawOnParentResize: true,
    width: "100%",
    height: "100%",
  },
  title: {
    text: `Breakdown of phenotypes associated with ${props.node.name}`,
  },
  colors: [theme.theme],
  plotOptions: {
    bar: {
      horizontal: true,
    },
  },
  tooltip: {
    enabled: false,
  },
  xaxis: {
    title: {
      text: "# of Phenotypes",
    },
    axisBorder: {
      color: "#000000",
    },
    axisTicks: {
      show: true,
      color: "#000000",
    },
  },
  yaxis: {},
  grid: {
    xaxis: {
      lines: {
        show: false,
      },
    },
    yaxis: {
      lines: {
        show: false,
      },
    },
  },
}));

/** get chart data */
const {
  query: getData,
  data: series,
  isLoading,
  isError,
} = useQuery(
  async function () {
    const data = await getHistoPheno(props.node.id);

    return [
      {
        name: "phenotypes",
        data: data.map((d) => ({ x: d.name, y: d.count })),
      },
    ];
  },

  /** default value */
  []
);

/** when path (not hash or query) changed, get new chart data */
watch([() => route.path, () => props.node.id], getData, { immediate: true });

return (_ctx: any,_cache: any) => {
  const _component_AppStatus = _resolveComponent("AppStatus")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isLoading))
      ? (_openBlock(), _createBlock(_component_AppStatus, {
          key: 0,
          code: "loading"
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }))
      : (_unref(isError))
        ? (_openBlock(), _createBlock(_component_AppStatus, {
            key: 1,
            code: "error"
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
    (_unref(series).length)
      ? (_openBlock(), _createBlock(_unref(Apex), {
          key: 2,
          type: "bar",
          options: _unref(options),
          series: _unref(series)
        }, null, 8, ["options", "series"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})